<template>
	<div class="ccl-selector">
		<CclAccordion
			:items="itemsAvailables"
			@active-clients="updateClientsSelected"
			@change="updateItemsData"
			class="ccl-selector__left"
		/>
		<CCLSelected
			:itemsSelected="itemsSelected"
			class="ccl-selector__right"
		/>
	</div>
</template>

<script>
import CclAccordion from '@/components/ccl-selector/ccl-left-side/ccl-accordion.vue';
import CCLSelected from '@/components/ccl-selector/ccl-right-side/ccl-selected-list.vue';

export default {
	components: {
		CclAccordion,
		CCLSelected
	},
	props: {
		items: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			itemsAvailables: [...this.items],
			itemsSelected: []
		};
	},
	methods: {
		updateClientsSelected(value) {
			this.itemsSelected = value;
			this.$emit('active-clients', value);
		},
		updateItemsData(value) {
			this.$parent.$emit('change', value);
			this.$emit('change', value);
		}
	}
};
</script>

<style lang="scss" scoped>
.ccl-selector {
	display: flex;
	justify-content: space-between;
	width: 100%;
	gap: $gutter-xxl;
	height: 100%;
	flex: 1;
	overflow: auto;

	&__left {
		width: 65%;
		display: flex;
		align-items: stretch;
	}
	&__right {
		width: 35%;
		display: flex;
		align-items: stretch;
	}

	@include mq($until: lg) {
		flex-direction: column;
		justify-content: flex-start;

		&__left {
			width: 100%;
			display: flex;
			align-items: stretch;
			height: 40vh;
		}

		&__right {
			width: 100%;
			display: flex;
			align-items: stretch;
			height: 23vh;
		}
	}
}
</style>
